import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../helpers/auth.services';
import { SharedService } from 'src/app/shared/shared.service';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UserMenuComponent implements OnInit {
  public userImage = "assets/img/users/user.jpg";
  // defaultImage: any = environment.baseUrlImage + '/assets/images/profile.png';
   defaultImage:any = environment.baseUrlImage + '/ec-admin-dev-ui/assets/images/profile.png';
  private currentUserSubject: BehaviorSubject<any>;

  firstName:any;
  lastName:any;
  designation:any;
  image:any;

  constructor(private router: Router,
    private authenticationService: AuthenticationService,
    private sharedService:SharedService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    
    this.getUserInfo();
  }


  getUserInfo() {
     this.sharedService.userShortInfo(localStorage.getItem("userid")).subscribe(data =>{
      this.firstName = data.firstName;
      this.lastName = data.lastName;
      this.designation = data.designation;
      if(data.imageName != environment.baseUrlImage+'/null'){
        
        this.image = data.imageName;
      }
      if(!data.active){
        this.removeUser();
      }
  });
  }

  
  removeUser() {
   window.sessionStorage.removeItem('currentUser');
   window.localStorage.clear();
    this.router.navigate(['/landing']);
    this.authenticationService.logout();
  }

 
}
